<template>
  <b-dropdown
    ref="dropdownForm"
    size="sm"
    variant="primary"
    text="Templates"
    class="mr-1"
  >
    <b-dropdown-form>
      <b-list-group flush>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          <b-form-checkbox
            v-model="isSelectedAllTemplate"
            size="sm"
            @change="onSelectAllTemplates"
          >
            All templates
          </b-form-checkbox>
          <b-form-checkbox
            v-model="showProjectNames"
            size="sm"
            button
            :button-variant="showProjectNames ? 'primary' : 'outline-primary'"
          >
            <span
              v-b-tooltip.hover
              :title="showProjectNames ? 'Show Template Names' :'Show Project Names'"
              style="padding-right: 3px;"
            >
              <i
                :class="['fas', showProjectNames ? 'fa-file' : 'fa-folder']"
              />
            </span>
          </b-form-checkbox>
        </b-list-group-item>
        <b-list-group-item
          v-for="template in templates"
          :key="template.instanceId"
          :disabled="getCurrentInstanceId === template.instanceId"
        >
          <b-form-checkbox
            v-model="template.isSelected"
            :disabled="getCurrentInstanceId === template.instanceId"
            size="sm"
            @change="onSelectTemplate"
          >
            <template v-if="showProjectNames && template.project_name">
              {{ template.project_name }}
            </template>
            <template v-else>
              {{ template.name }}
            </template>
          </b-form-checkbox>
        </b-list-group-item>
      </b-list-group>
    </b-dropdown-form>
    <div class="d-flex justify-content-end p-2">
      <b-button
        size="sm"
        variant="primary"
        @click="apply"
      >
        Apply
      </b-button>
    </div>
  </b-dropdown>
</template>

<script>
import {mapGetters} from 'vuex'
import selectedTemplateForApplyToAll
  from '../../../../../group/modules/editor-control-popup/selected-template-for-apply-to-all';

export default {
  props: {
    localStorageKey: {
      type: String,
      default: '',
      require: true,
    },
    clearLocalStorage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSelectedAllTemplate: true,
      showProjectNames: true,
      templates: [],
    }
  },
  computed: {
    ...mapGetters('layout', [
      'selectedInstance',
    ]),
    getCurrentInstanceId() {
      return this.selectedInstance.id
    },
  },
  watch: {
    getCurrentInstanceId() {
      this.initSelectTemplates();
    },
  },
  mounted() {
    this.initSelectTemplates();
  },
  methods: {
    initSelectTemplates() {
      if (this.clearLocalStorage) {
        localStorage.setItem(this.localStorageKey, []);
      }
      const selectedTemplates = selectedTemplateForApplyToAll.getSelectedTempaltes(this.localStorageKey);
      const previews = window.previews || [];

      this.templates = previews.map(({id, template: {name}, data: {project_name}}) => ({
        instanceId: id,
        name,
        project_name,
        isSelected: this.getCurrentInstanceId === id ? true : selectedTemplateForApplyToAll.hasSelectedTemplates(this.localStorageKey, id),
      }));

      selectedTemplates.forEach((instanceID) => {
        const template = this.templates.find(template => template.instanceId === instanceID);

        if (template) {
          template.isSelected = true;
        }
      });

      this.isSelectedAllTemplate = !this.templates.find(template => !template.isSelected);
    },
    onSelectTemplate() {
      this.isSelectedAllTemplate = !this.templates.find(template => !template.isSelected);

      this.templates.forEach(template => {
        if (template.isSelected) {
          selectedTemplateForApplyToAll.addSelectedTemplate(template.instanceId, this.localStorageKey)
        } else {
          selectedTemplateForApplyToAll.removeSelectedTemplate(template.instanceId, this.localStorageKey)
        }
      });
    },
    onSelectAllTemplates() {
      this.templates.forEach(template => {
        if (template.instanceId !== this.getCurrentInstanceId) {
          template.isSelected = this.isSelectedAllTemplate;
        }

        if (template.isSelected) {
          selectedTemplateForApplyToAll.addSelectedTemplate(template.instanceId, this.localStorageKey)
        } else {
          selectedTemplateForApplyToAll.removeSelectedTemplate(template.instanceId, this.localStorageKey)
        }
      });
    },
    apply() {
      this.$emit('call-apply');
      this.$refs.dropdownForm.hide();
    },
    resetProperties() {
      this.templates.forEach(template => {
        template.isSelected = false;
      });
      this.isSelectedAllTemplate = false;
    },
  }
}
</script>

<style scoped lang="scss">
.b-dropdown-form {
  width: 418px;
  overflow: auto;
  overflow-wrap: anywhere;
  padding: 0;
}
</style>
